/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { User, UserData } from '../../@core/interfaces/common/users';
import { tap } from 'rxjs/operators';
import { UserStore } from '../../@core/stores/user.store';
import { Injectable } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import {  UserTypeValue } from '../../@core/interfaces/common/users';
import { Router } from '@angular/router';
import { SharedService } from '../../@core/interfaces/masters/SharedService';


@Injectable()
export class InitUserService {
    constructor(protected userStore: UserStore,
        protected usersService: UserData,protected router: Router,
        protected themeService: NbThemeService,private sharedService:SharedService,) { }

    initCurrentUser(): Observable<User> {
      return this.usersService.getCurrentUser()
            .pipe(tap((user: User) => {
                if (user) { 
                    this.userStore.setUser(user);
                    localStorage.setItem("isSuperUser",user.isSuperUser);
                    localStorage.setItem("tenantId",user.tenantId);
                  //  localStorage.setItem("branchId",user.branchId);
                    localStorage.setItem('userId',(user.id).toString());
                    localStorage.setItem('userName',(user.firstName!==null?user.firstName:'')+" "+(user.lastName!==null?user.lastName:''));
                    if(user.userType != null)
                    localStorage.setItem('userType',(user.userType).toString());
                    else
                    localStorage.setItem('userType',null);
                    
                    // localStorage.setItem('loginuser',"patientlogin");
                    localStorage.setItem('loginuser',(user.loginUserType));
                    localStorage.setItem('landingPageUrl',(user.landingPageUrl));
                    localStorage.setItem('userFlag',(user.userFlag));

                    if(user.userFlag == UserTypeValue.PHYSICIAN && user.phyId != null)
                    localStorage.setItem('physicianId',(user.phyId).toString());
                    else
                    localStorage.setItem('physicianId',(0).toString());

                    if(user.userFlag == UserTypeValue.EMPLOYEE && user.empId != null)
                    localStorage.setItem('employeeId',(user.empId).toString());
                    else
                    localStorage.setItem('employeeId',(0).toString());

                   localStorage.setItem('passwordResetFlag',user.passwordResetFlag == null ? "false" : (user.passwordResetFlag).toString());
                   localStorage.setItem('passwordResetDate',user.passwordResetDate == null ? null : (user.passwordResetDate).toString());
    
                   localStorage.setItem("discReqMethod", user?.discReqMethod ?? 'Manual');
                   let extractUserJson=JSON.parse(user?.userJson);
                   this.sharedService.updatePrintAdminStatus({isPrintAdmin:(extractUserJson?.printAdministrator)??false});
                    let timeoutValue = parseInt(user?.sessionTimeOut?.toString() || "NaN");
                    localStorage.setItem('sessionTimeOutSettings', (isNaN(timeoutValue) ? 1440 : timeoutValue).toString());


                    if (user.settings && user.settings.themeName) {
                      this.themeService.changeTheme(user.settings.themeName);
                    }
                }
                window.onstorage = event => { 
                  if (event.key == 'branchId')
                  {
                    if(event.newValue != event.oldValue )
                    {
                      this.router.navigateByUrl("pages/patientservices/app").then(() => {
                    window.location.reload();
                  });
                    }
                    else
                        return;
                  }
                  else
                        return;
                  
                };
               
            }));
    }
}
